import "./Tabs.scss";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { replaceUnderscore } from "../../../CommonFunction/common";
interface TabType {
  name: string;
}
interface TabsProps {
  tabs: TabType[];
  SetTabPage?: (name: string) => void;
  ActiveIndex?: Number;
}

export const Tabs = ({ tabs, SetTabPage, ActiveIndex = 0 }: TabsProps) => {
  // let { data } = useQuery(GetIssue, {
  //   variables: { Status: "Unread" },
  //   fetchPolicy: "network-only",
  // });

  const [activeTab, setActiveTab] = useState(ActiveIndex);
  const [Tabs, setTabs] = useState<TabType[]>(tabs);
  const dispatch = useDispatch();
  const SetTabName = (t: String) => {
    dispatch({ type: "TabData", payload: { tab: t } });
  };

  useEffect(() => {
    setTabs(tabs);
  }, [tabs]);

  return (
    <div className="tab-system">
      <div className="tab-headers tab-headers--wrap">
        {Tabs?.map((tab, index) => {
          return (
            <div
              key={index}
              className={`tab-header ${activeTab === index ? "active" : ""}`}
              onClick={() => {
                setActiveTab(index);
                SetTabName(tab.name);
                if (SetTabPage) {
                  SetTabPage(tab.name);
                }
              }}
            >
              {replaceUnderscore(tab.name)}
            </div>
          );
        })}
      </div>
    </div>
  );
};
